module.exports = __webpack_public_path__ + "img/authorized_signature.8bb008d4.svg";